import { BigNumber } from 'ethers'
import { VESISConfig } from '~/types/config'

interface GraphUserInfo {
	totalRewards: BigNumber
	lastLockTime: BigNumber
	lastClaimedAt?: BigNumber
}

export async function getGraphUserInfo(
	config: VESISConfig,
	account: string
): Promise<GraphUserInfo | null> {
	const response = await fetch(config.theGraphURL, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			query: `{
				user(id: "${account.toLowerCase()}") {
					totalRewards
					lastLockTime
				}
				claimeds(
				    orderBy: blockTimestamp
					orderDirection: desc
					first: 1,
					where:{recipient:"${account.toLowerCase()}"}
				) {
					amount
					blockTimestamp
					recipient
			    }
			}
			`,
		}),
	})

	const { data } = await response.json()

	if (!data.user || !data.claimeds) {
		return null
	}

	const lastLockTime = BigNumber.from(data.user.lastLockTime)
	const totalRewards = BigNumber.from(data.user.totalRewards)

	if (data.claimeds.length === 0) {
		return {
			totalRewards,
			lastLockTime,
		}
	}

	let lastClaimedAt = BigNumber.from(data.claimeds[0].blockTimestamp)
	if (lastClaimedAt.lte(lastLockTime)) {
		return {
			totalRewards,
			lastLockTime,
		}
	}

	return {
		totalRewards,
		lastLockTime,
		lastClaimedAt,
	}
}
